import {CommonModule} from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {Route, RouterModule} from '@angular/router';
import {TranslateModule} from '@ox/translate';
import {TrackingModule} from '@ox/data';
import {LoadingModule} from '@ox/ui';
import {ShopServiceModule, AssetsService} from '@webu/data';
import {CarouselModule} from 'ngx-bootstrap/carousel';
import {ModalModule} from 'ngx-bootstrap/modal';
import {MyPlansUnifiedModule} from '../../my-plans-unified';
import {BillingCycleToggleComponent} from '../update-plans/billing-cycle-toggle/billing-cycle-toggle.component';
import {BuildYourOwnComponent} from '../update-plans/build-your-own/build-your-own.component';
import {ChatFooterComponent} from '../update-plans/chat-footer/chat-footer.component';
import {DisclosureModalComponent} from '../update-plans/disclosure-modal/disclosure-modal';
import {ManageFeaturedPlanComponent} from '../update-plans/manage-featuredplan/manage-featuredplan.component';
import {PaymentFooterComponent} from '../update-plans/payment-footer/payment-footer.component';
import {RollInRollOutModalComponent} from '../update-plans/roll-in-roll-out-modal/roll-in-roll-out-modal';
import {ServiceModalComponent} from '../update-plans/service-modal/service-modal';
import {StepperHeadingComponent} from '../update-plans/stepper-heading/stepper-heading.component';
import {UpdatePlansComponent} from '../update-plans/update-plan.component';
import {ManageComponent} from './manage-plans.component';
import {CheckoutNavigationService} from '../../services';

const ROUTES: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        outlet: 'modify',
        component: UpdatePlansComponent
      },
      {
        path: '',
        outlet: 'bill',
        component: BillingCycleToggleComponent
      }
    ],
    component: ManageComponent
  }
];

@NgModule({
  declarations: [
    ManageComponent,
    UpdatePlansComponent,
    BuildYourOwnComponent,
    ManageFeaturedPlanComponent,
    DisclosureModalComponent,
    RollInRollOutModalComponent,
    StepperHeadingComponent,
    ChatFooterComponent,
    PaymentFooterComponent,
    BillingCycleToggleComponent,
    ServiceModalComponent
  ],
  imports: [
    CarouselModule.forRoot(),
    RouterModule.forChild(ROUTES),
    CommonModule,
    TranslateModule,
    TrackingModule,
    ModalModule.forRoot(),
    MyPlansUnifiedModule,
    ShopServiceModule,
    LoadingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    AssetsService, 
    CheckoutNavigationService
  ]
})
export class ManagePlansModule {
}
